<template>
<div>
  <v-row no-gutters>
    <v-col class="pa-0 mb-5 col-auto" id="checkbox-multilines"
           v-visible="!this.hideEmailSubscription">
      <validation-provider v-slot="{ errors }" :rules="{required_if: !this.hideEmailSubscription && this.isRequiredEmailSubscription , allowFalse: false}"
                           name="キャンペーンなどお得なご案内をメールで受け取る">
        <v-checkbox
          v-model="emailSubscriptionCode"
          :error-messages="errors"
          type="checkbox"
          dense
          height="auto"
          name="emailSubscriptionCode"
          :ripple="false"
          :class="{'agreement-checkbox' : $vuetify.breakpoint.mdAndUp}"
          hide-details="auto"
        >
          <template #label>
            <div class="text-body-2">キャンペーンなどお得なご案内をメールで受け取る</div>
            <slot name="annotation"/>
          </template>
        </v-checkbox>
      </validation-provider>
    </v-col>
  </v-row>
</div>
</template>

<script>
export default {
  name: "vb-email-subscription",
  props: {
    formItemsSetter: {
      type: Function,
      required: true
    },
    formItemsGetter: {
      type: Object,
      required: true,
      default: {}
    },
    hideEmailSubscription: {
      type: Boolean,
      required: false,
      default: false,
    },
    isRequiredEmailSubscription: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    emailSubscriptionCode: {
      get() {
        return this.formItemsGetter.emailSubscriptionCode;
      },
      set(event) {
        this.formItemsSetter({name: 'emailSubscriptionCode', value: event})
      }
    },
  }
}
</script>

<style scoped lang="scss">
.row {
  margin-top: 0;
  margin-bottom: 0;
}

::v-deep {
  #checkbox-multilines label {
    display: block;
  }

  .v-input--checkbox {
    label {
      color: rgba(0, 0, 0, 0.87);
    }
    .v-input__slot {
      align-items: flex-start;
    }
  }
  .agreement-checkbox {
    .v-icon {
      font-size: 28px;
    }
  }
}
</style>